import type { StationBoardJourneysType, StationBoardType } from '@/types';

import sortByTime from '@/utils/helpers/sort-by-time';

export interface StationBoardListItem {
  journey: StationBoardType;
  arrival?: { time: string; deviation?: number };
  departure?: { time: string; deviation?: number };
}

export const getStationBoardListItems = (stationRouteData: StationBoardJourneysType | null) => {
  if (!stationRouteData?.journeys) {
    return { arrivals: [], departures: [] };
  }

  const { arrivals, departures } = stationRouteData.journeys.reduce(
    (acc, journey) => {
      if (journey.arrival !== null) {
        acc.arrivals.push({
          journey,
          arrival: { time: journey.arrival, deviation: journey.arrivalDeviation },
        });
      }

      if (journey.departure !== null) {
        acc.departures.push({
          journey,
          departure: { time: journey.departure, deviation: journey.departureDeviation },
        });
      }

      return acc;
    },
    { arrivals: [] as StationBoardListItem[], departures: [] as StationBoardListItem[] }
  );

  return {
    arrivals: arrivals.sort(sortByTime('arrival')),
    departures: departures.sort(sortByTime('departure')),
  };
};
